import { render, staticRenderFns } from "./debug_tab_segment.vue?vue&type=template&id=eae7ddcc&scoped=true&"
import script from "./debug_tab_segment.vue?vue&type=script&lang=js&"
export * from "./debug_tab_segment.vue?vue&type=script&lang=js&"
import style0 from "./debug_tab_segment.vue?vue&type=style&index=0&id=eae7ddcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eae7ddcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/deploy/beta-web-new/web_head/releases/20260820083957/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eae7ddcc')) {
      api.createRecord('eae7ddcc', component.options)
    } else {
      api.reload('eae7ddcc', component.options)
    }
    module.hot.accept("./debug_tab_segment.vue?vue&type=template&id=eae7ddcc&scoped=true&", function () {
      api.rerender('eae7ddcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/desktop/debug/debug_tab_segment.vue"
export default component.exports